import EventBus from './lib/EventBus';

export default EventBus;